import { Horizontal } from "@/components/standard/BFLayout"
import { H5, Small } from "@/components/standard/BFText"
import { Linking, Pressable, View } from "react-native"
import Shuffle from "phosphor-react-native/src/icons/Shuffle"
import ArrowRight from "phosphor-react-native/src/icons/ArrowRight"

const DSCR_URL = "https://backflip.com/loans/dscr/inquiry-form/"

export const DSCRBanner = () => {
  return (
    <View className="px-5 py-3">
      <Pressable
        testID="dscr-banner"
        onPress={() => {
          void Linking.openURL(DSCR_URL)
        }}
      >
        <Horizontal className="bg-teal rounded-lg px-4 py-3 items-center gap-3">
          <Shuffle size={24} color="#121F3A" />
          <View className="flex-1">
            <H5 color="primary">Looking for a rental loan (DSCR)?</H5>
            <Horizontal className="items-center gap-1">
              <Small className="underline">
                Submit an inquiry here
              </Small>
              <ArrowRight size={12} color="#121F3A" />
            </Horizontal>
          </View>
        </Horizontal>
      </Pressable>
    </View>
  )
}
